import React, { Component, ReactNode, useEffect, useState } from 'react';

const STORAGE_KEY = 'chunk-load-reload';

function isChunkLoadError(error: Error): boolean {
  return error.name === 'ChunkLoadError' || /Loading chunk [\w.-]+ failed/.test(error.message);
}

interface Props {
  children?: ReactNode;
}

interface State {
  hasChunkError: boolean;
}

class ChunkLoadErrorBoundaryInner extends Component<Props, State> {
  state: State = { hasChunkError: false };

  static getDerivedStateFromError(error: Error): State | null {
    if (!isChunkLoadError(error)) return null;
    return { hasChunkError: true };
  }

  componentDidCatch() {
    if (!this.state.hasChunkError) return;
    sessionStorage.setItem(STORAGE_KEY, 'true');
    window.location.reload();
  }

  render() {
    if (this.state.hasChunkError) return null;
    return this.props.children;
  }
}

const ChunkLoadErrorBoundary: React.FC<Props> = ({ children }) => {
  const [skipBoundary] = useState(() => sessionStorage.getItem(STORAGE_KEY) === 'true');

  useEffect(() => {
    if (skipBoundary) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }, [skipBoundary]);

  if (skipBoundary) return <>{children}</>;
  return <ChunkLoadErrorBoundaryInner>{children}</ChunkLoadErrorBoundaryInner>;
};

export default ChunkLoadErrorBoundary;
